import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

/**
 * The CSV / PDF pair that sits above an exportable table (#1411: "anytime there is a table of information,
 * have an export by pdf and csv option").
 *
 * One component so every table offers the same two buttons in the same place with the same words — an export
 * that is called "Download CSV" on one screen and "Export" on the next reads as two different features.
 * Building the file is the screen's job, via TableExportService; this only asks for it.
 */
@Component({
  selector: 'app-table-export-buttons',
  standalone: true,
  imports: [MatButton, MatIcon],
  template: `
    <div class="table-export-buttons">
      <button mat-stroked-button
              type="button"
              [disabled]="disabled"
              (click)="exportCsv.emit()"
              [attr.data-testid]="testIdPrefix + '-export-csv-button'">
        <mat-icon>table_view</mat-icon>
        Export CSV
      </button>
      <button mat-stroked-button
              type="button"
              [disabled]="disabled"
              (click)="exportPdf.emit()"
              [attr.data-testid]="testIdPrefix + '-export-pdf-button'">
        <mat-icon>picture_as_pdf</mat-icon>
        Export PDF
      </button>
    </div>
  `,
  styles: [`
    .table-export-buttons {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
      margin: 0.5rem 0;
    }
  `]
})
export class TableExportButtonsComponent {

  /** Distinguishes the pairs when a page has more than one exportable table. */
  @Input() testIdPrefix: string = 'table';

  /**
   * Set while the table is still loading. Not set for an empty table: exporting one is legitimate — "this
   * charity has been paid nothing" is an answer an auditor may want in writing.
   */
  @Input() disabled: boolean = false;

  @Output() exportCsv: EventEmitter<void> = new EventEmitter<void>();
  @Output() exportPdf: EventEmitter<void> = new EventEmitter<void>();
}
